import { Scene, GameObjects } from 'phaser';

export class GameInfoUI {
  private scene: Scene;
  private scoreText!: GameObjects.Text;
  private waveText!: GameObjects.Text;
  private unitsText!: GameObjects.Text;
  private healthBar?: GameObjects.Graphics;
  private score: number = 0;
  private wave: number = 1;
  private availableUnits: number = 0;

  constructor(scene: Scene) {
    this.scene = scene;
    this.createUI();
    this.setupEventListeners();
  }

  private createUI(): void {
    // Score display
    this.scoreText = this.scene.add.text(10, 10, `Score: ${this.score}`, {
      fontSize: '16px',
      fontFamily: 'Courier New',
      color: '#ffffff'
    });

    // Wave display
    this.waveText = this.scene.add.text(10, 30, `Wave: ${this.wave}`, {
      fontSize: '16px',
      fontFamily: 'Courier New',
      color: '#ffffff'
    });

    // Available units display
    this.unitsText = this.scene.add.text(10, 50, `Units: ${this.availableUnits}`, {
      fontSize: '16px',
      fontFamily: 'Courier New',
      color: '#00ffff'
    });

    // Base health bar
    // this.createHealthBar();
  }

  

  private setupEventListeners(): void {
    this.scene.events.on('score-updated', (score: number) => {
      this.setScore(score);
    });

    this.scene.events.on('wave-updated', (wave: number) => {
      this.setWave(wave);
    });

    this.scene.events.on('base-health-updated', (health: number, maxHealth: number) => {
      this.setBaseHealth(health, maxHealth);
    });

    this.scene.events.on('enemy-destroyed', () => {
      this.addScore(10);
    });

    this.scene.events.on('unit-available', (availableUnits: number) => {
      this.setAvailableUnits(availableUnits);
    });

    this.scene.events.on('unit-consumed', (availableUnits: number) => {
      this.setAvailableUnits(availableUnits);
    });
  }

  public setScore(score: number): void {
    this.score = score;
    this.scoreText.setText(`Score: ${this.score}`);
  }

  public setWave(wave: number): void {
    this.wave = wave;
    this.waveText.setText(`Wave: ${this.wave}`);
  }

  public setAvailableUnits(units: number): void {
    this.availableUnits = units;
    this.unitsText.setText(`Units: ${this.availableUnits}`);
  }

  public setBaseHealth(_health: number, _maxHealth: number): void {
    // Store health values for potential future use
    // this.baseHealth = health;
    // this.maxBaseHealth = maxHealth;
  }

  public addScore(points: number): void {
    this.score += points;
    this.setScore(this.score);
    this.scene.events.emit('score-updated', this.score);
  }

  public getScore(): number {
    return this.score;
  }

  public getWave(): number {
    return this.wave;
  }

  public destroy(): void {
    this.scene.events.off('score-updated');
    this.scene.events.off('wave-updated');
    this.scene.events.off('base-health-updated');
    this.scene.events.off('enemy-destroyed');
    this.scene.events.off('unit-available');
    this.scene.events.off('unit-consumed');

    this.scoreText.destroy();
    this.waveText.destroy();
    this.unitsText.destroy();
    
    // Only destroy healthBar if it exists
    if (this.healthBar) {
      this.healthBar.destroy();
    }
  }
}
